import { global } from ":shared/app";

const endpoint = (email: string) => "/account/attendance/accepted?email=" + email;
export type GET = {
  props: {
    email: string;
  };
  returns: {
    guide_ar: string;
    guide_en: string;
    badge: string;
    apple_walled: string;
    email: string;
    name_ar: string;
    name_en: string;
    attendance_status: boolean;
  };
};
export async function get(props: GET["props"]): Promise<GET["returns"]> {
  // return import("./accepted.mocks").then((ret) => {
  //   return ret.success;
  // });
  return global.api.get(endpoint(props.email)).then((res) => {
    return res.data;
  });
}
